export const getBuildSpecs = async (id) => {
    //console.log('Fetching buildspecs for', id);
    //console.log('API: ', process.env.API);
    // console.log('url', `${process.env.API}/buildspec/organization/${id}`);
    try {
        const resp = await fetch(`${process.env.API}/buildspec/list/${id}`);
        if (!resp.ok) {
            throw new Error(`Failed to fetch buildspecs: ${resp.status}`);
        }
        return resp.json();
    }
    catch (error) {
        console.error('Error fetching buildspecs', error);
        return [];
    }
};
export const getAllBuildSpecs = async () => {
    //console.log('Fetching all buildspecs');
    console.log(`${process.env.API}/buildspec/list`);
    try {
        const resp = await fetch(`${process.env.API}/buildspec/list`);
        if (!resp.ok) {
            throw new Error(`Failed to fetch buildspecs: ${resp.status}`);
        }
        return resp.json();
    }
    catch (error) {
        console.error('Error fetching buildspecs', error);
        return [];
    }
};
export const getUserByKeycloakId = async (userId) => {
    //console.log('Fetching user', userId);
    //console.log(`${process.env.API}/user/${userId}`);
    try {
        const resp = await fetch(`${process.env.API}/hologramd/${userId}`);
        if (!resp.ok) {
            throw new Error(`Failed to fetch user: ${resp.status}`);
        }
        return resp.json();
    }
    catch (error) {
        console.error('Error fetching user', error);
        return null;
    }
};
export const getUserByUserName = async (userName) => {
    //console.log('Fetching user', userId);
    //console.log(`${process.env.API}/user/${userId}`);
    try {
        const resp = await fetch(`${process.env.API}/hologramd/user/${userName}`);
        if (!resp.ok) {
            throw new Error(`Failed to fetch user: ${resp.status}`);
        }
        return resp.json();
    }
    catch (error) {
        console.error('Error fetching user', error);
        return null;
    }
};
export const getTemplate = async (name) => {
    try {
        const resp = await fetch(`/templates/${name}.html`);
        const template = await resp.blob();
        return template.text();
    }
    catch (error) {
        return null;
    }
};
export const getPaymentStatus = async (buildSpecId, userid) => {
    console.log('Fetching payment status for buildspec', buildSpecId);
    console.log('API: ', process.env.API);
    console.log('url', `${process.env.API}/onpay/payment/${buildSpecId}/${userid}`);
    try {
        const resp = await fetch(`${process.env.API}/onpay/payment/${buildSpecId}/${userid}`);
        return resp.json();
    }
    catch (error) {
        console.error('Error fetching payment status', error);
        return null;
    }
};
